import React from 'react'
import img1 from './../../assets/sliderImages/1.gif'
import img2 from './../../assets/sliderImages/2.png'
import img3 from './../../assets/sliderImages/3.png'
import img4 from './../../assets/sliderImages/4.png'
import img5 from './../../assets/sliderImages/5.png'
import img6 from './../../assets/sliderImages/6.png'
import img7 from './../../assets/sliderImages/7.png'
// import sideImg from './../../assets/images/sideImg.png'
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./../../index.css";
import "./../../mainslider.css"
import { Autoplay, Navigation, Pagination } from "swiper";
const MainSlider = () => {
    const images = [img1, img2, img3, img4, img5, img6, img7]
    return (
        <>
            <div className="flex relative container max-md:flex-wrap gap-4">
                <Swiper
                    modules={[Autoplay, Navigation, Pagination]}
                    spaceBetween={10}
                    slidesPerView={1}
                    navigation={true}
                    loop={true}
                    parallax={true}
                    keyboard={{ enabled: true }}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false
                    }}
                    className="h-auto cursor-pointer select-none m-auto max-md:w-full md:rounded-lg mySlider"
                >
                    {
                        images.map((swiperItem, i) => {
                            return (
                                <SwiperSlide key={i} className="flex justify-center items-center w-full h-full md:rounded-lg min-h-[150px]">
                                    <div className="row">
                                        <img className=" md:rounded-lg min-h-[150px]" src={swiperItem} alt={`"slider`} />
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
                {/* <div className="w-full p-2 flex items-center justify-center md:w-4/12  max-md:hidden">
                    <div className="img-bg h-full mt-3 rounded-lg" >
                        <img src={sideImg} alt="" />
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default MainSlider